module.exports = __webpack_public_path__ + "static/media/other-expenses.21b25ef9.svg";